import { useState, useCallback } from 'react';
import { copyRich } from '../../utils/markdown';

/* Bouton « copier » minimal (rich HTML + texte) — extrait tel quel de
 * ResultsDisplay.tsx (ancien CopyBtn). Comportement identique. */

export default function CopyButton({ text, hidden }: { text: string; hidden?: boolean }) {
  const [ok, setOk] = useState(false);
  const copy = useCallback(async () => {
    await copyRich(text);
    setOk(true);
    setTimeout(() => setOk(false), 2000);
  }, [text]);
  if (hidden) return null;
  return (
    <button onClick={copy} title="Copier" className="p-1 rounded text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-colors">
      {ok ? (
        <svg className="w-3.5 h-3.5 text-emerald-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
      ) : (
        <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>
      )}
    </button>
  );
}
